<div class="x-auth-wrapper">
  <span class="header_title">{{ loginText }}</span>
  <form [formGroup]="loginForm" class="form-wrapper" (ngSubmit)="onSubmit()">
    <div class="email">
      <label class="email_title">Login/E-mail:</label>
      <input
        #loginInput
        id="mobile-auth_login-input"
        autocomplete
        class="email_input"
        type="email"
        formControlName="email"
        (focus)="onFocus()"
        required
      />

      <div class="warn">
        <p
          class="warning"
          [ngStyle]="{
            visibility: (messageVissibilitySatus$ | async) === false ? 'visible' : 'hidden'
          }"
          *ngIf="
            (!loginForm.get('email')?.valid && loginForm.get('email')?.dirty) ||
            (isSubmitted && loginForm.get('email')!.hasError('required'))
          "
        >
          {{ requiredTxt }}
        </p>
      </div>
    </div>

    <div class="password">
      <label class="password_title">Hasło:</label>
      <input
        #passwordInput
        id="mobile-auth_password-input"
        autocomplete
        class="password_input"
        [type]="show ? 'text' : 'password'"
        formControlName="password"
        (focus)="onFocus()"
        required
      />

      <div class="warn">
        <p
          class="error"
          *ngIf="
            isSubmitted &&
            !loginForm.get('password')!.hasError('required') &&
            !loginForm.get('email')!.hasError('required') &&
            (loginStatus$ | async) === false
          "
        >
          {{ loginOrPassDoesNotExistText }}
        </p>

        <p
          [ngStyle]="{
            visibility: (messageVissibilitySatus$ | async) === false ? 'visible' : 'hidden'
          }"
          class="warning"
          *ngIf="
            (!loginForm.get('password')?.valid && loginForm.get('password')?.dirty) ||
            (isSubmitted && loginForm.get('password')!.hasError('required'))
          "
        >
          {{ requiredTxt }}
        </p>
      </div>

      <button
        id="mobile-auth_show-password-button"
        class="show-btn"
        (click)="passwordShow()"
        type="button"
      >
        <app-icon [name]="show ? 'show-password' : 'hide-password'"></app-icon>
      </button>
    </div>

    <ng-container *ngIf="isOnlineMode$ === true; else notConnected">
      <ng-container *ngIf="(loginStatus$ | async) === false; else update">
        <button id="mobile-auth_submit-button_connected" class="submit-btn" type="submit">
          Zaloguj
        </button>
      </ng-container>
      <ng-template #update>
        <app-spinner class="spinner" color="#707070"></app-spinner>
      </ng-template>
    </ng-container>
    <ng-template #notConnected>
      <button
        id="mobile-auth_submit-button-no_connected"
        type="button"
        [ngStyle]="{
          'background-color': isOnlineMode$ === false ? '#808080' : '#ec5800'
        }"
        class="submit-btn"
        (click)="displayOfflineModal()"
      >
        Zaloguj
      </button>
    </ng-template>
  </form>

  <hr class="line" />

  <div class="bottom-wrapper">
    <div class="bottom-item">
      <span class="dot"></span>

      <a id="mobile-auth_no-account-link" class="account-btn" href="{{ registryGwoUrl }}">{{
        doNotHaveAnAccountText
      }}</a>
    </div>
    <div class="bottom-item">
      <span class="dot"></span>
      <a
        id="mobile-auth_forgot-password-link"
        class="account-btn"
        href="{{ rememberPasswordPageUrl }}"
        >{{ rememberPassTxt }}</a
      >
    </div>
    <div class="bottom-item">
      <span class="dot"></span>
      <a
        id="mobile-auth_delete-account-help"
        class="account-btn"
        href="{{ deleteAccountHelpPageUrl }}"
        >{{ deleteAccountHelpTxt }}</a
      >
    </div>
    <div class="bottom-item">
      <span class="dot"></span>
      <a
        id="mobile-auth_privacy-policy-help"
        class="account-btn"
        href="{{ privacyPolicyPageUrl }}"
      >{{ privacyPolicyHelpTxt }}</a
      >
    </div>
  </div>
</div>
